import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "21",
  height: "21",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M17.406 6.916h-.895V1.458q0-.426-.256-.672-.256-.245-.661-.245H4.677q-.405 0-.661.245-.256.246-.256.672v5.458h-.896q-1.172 0-1.95.779-.78.778-.779 1.95v4.542q0 1.151.779 1.94.778.79 1.95.79h.896v2.728q0 .404.256.662.255.255.66.255h10.918q.405 0 .66-.256.256-.255.256-.66v-2.73h.896q1.173 0 1.951-.789.778-.788.778-1.94V9.646q0-1.173-.778-1.951-.779-.78-1.951-.779M5.594 2.353h9.083v4.563H5.594zm9.083 16.376H5.594V13.27h9.083zm3.646-4.542q0 .405-.245.661-.246.255-.672.256h-.895v-2.73q0-.427-.256-.67-.256-.246-.661-.246H4.677q-.405 0-.661.245t-.256.672v2.729h-.896q-.426 0-.671-.256-.246-.255-.245-.66V9.645q0-.428.245-.672t.671-.245h14.542q.426 0 .672.245.245.245.245.672z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }